import React from 'react';

export default class StickyHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      stick: false,
    };
    this.onScroll = this.onScroll.bind(this);

    this.content = React.createRef();
  }

  componentDidMount() {
    this.props.events.forEach((e) => this.props.window().addEventListener(e, this.onScroll)); // eslint-disable-line @typescript-eslint/unbound-method
    this.onScroll();
  }

  componentWillUnmount() {
    this.props.events.forEach((e) => this.props.window().removeEventListener(e, this.onScroll)); // eslint-disable-line @typescript-eslint/unbound-method
  }

  documentScrollTop() { // eslint-disable-line react/sort-comp
    const doc = this.props.document().documentElement;
    const st = (this.props.window().pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    return st;
  }

  elementOffset() {
    if (!this.content.current) {
      return 0;
    }
    const rect = this.content.current.getBoundingClientRect();
    const bodyRect = this.props.document().body.getBoundingClientRect();
    const elOffset = rect.top - bodyRect.top;
    return elOffset + this.props.offset;
  }

  onScroll(event) {
    // Obtain document scroll top which is a representation of the position
    // of the top of the page
    const documentScrollTop = this.documentScrollTop();

    // Obtain the position of the element
    const elementOffset = this.elementOffset();

    let stick = this.state.stick;
    if (documentScrollTop >= elementOffset) {
      stick = true;
    } else {
      stick = false;
    }

    // Don't update state unless previous stick values have changed. This is to
    // prevent unnecessary setState updates which trigger re-renders
    if (stick !== this.state.stick) {
      this.setState({
        stick,
      });
    }
  }

  render() {
    const stickyClass = this.state.stick ? this.props.stickyClass : '';
    const classes = [stickyClass, this.props.className].join(' ');
    return (
      <div className={classes} ref={this.content}>
        {this.props.children}
      </div>
    );
  }
}

StickyHeader.defaultProps = {
  window: () => window,
  document: () => document,
  stickyClass: '',
  offset: 110,
  events: ['scroll', 'resize', 'pageshow', 'load'],
};
